<template>
  <div class="pt-3">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon small @click="$router.go(-1)"
          ><v-icon>mdi-undo</v-icon></v-btn
        >
      </template>
      <span>Back</span>
    </v-tooltip>
    <div>
      <title-page title="Generate Contract" />
      <v-card class="mt-3 rounded-lg pa-3" flat>
        <div class="d-flex align-start">
          <v-icon class="mr-2" color="var(--g)">mdi-information-outline</v-icon>
        
        </div>
      </v-card>
      <v-card class="mt-3 rounded-lg pa-3" flat>
        <h3 class="mb-2">Select the type of contract</h3>
        <div style="width: 150px">
          <v-select
            dense
            hide-details
            :items="typeContract"
            item-text="txt"
            item-value="val"
            v-model="pickedContract"
            placeholder="Contract"
            background-color="var(--g)"
            dark
            flat
            solo
          ></v-select>
        </div>
      </v-card>
    </div>

    <v-card class="mt-3 rounded-lg pa-3" flat>
      <h3 class="mb-3">Select Scholar to send the contract</h3>
      <v-row>
        <v-col cols="12" md="10">
          <p class="default_txt">Search Scholar</p>
          <div class="d-flex align-center ml-2">
            <v-icon class="magnify">mdi-magnify</v-icon>
            <input
              type="text"
              placeholder="Search scholar"
              v-model="find"
              @keydown="fetchData"
              class="input_green"
            />
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <p class="default_txt">Filter Cohort</p>
          <v-select
            dense
            hide-details
            :items="getYear"
            item-text="state"
            item-value="abbr"
            v-model="year"
            @change="fetchData()"
            placeholder="Filter Year"
            background-color="var(--g)"
            dark
            flat
            solo
          ></v-select>
        </v-col>
      </v-row>
      <v-skeleton-loader type="table-tbody" v-if="loading"></v-skeleton-loader>

      <div v-if="dataSet && !loading">
        <v-data-table
          :headers="headers"
          :items="dataSet"
          :show-select="true"
          v-model="storage_id"
          :page.sync="page"
          :items-per-page="limit"
          class="elevation-0 color_txt"
          hide-default-footer
          :single-select="false"
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-btn
              small
              depressed
              dark
              color="var(--g)"
              v-if="item.data_scholar_contract"
            >
              contracted
            </v-btn>
            <v-btn
              small
              depressed
              dark
              color="grey"
              v-if="!item.data_scholar_contract"
            >
              not contracted
            </v-btn>
          </template>
          <template v-slot:[`item.type`]="{ item }">
            <b v-if="item.data_scholar_contract">
              {{ item.data_scholar_contract.type }}</b
            >
          </template>
          <template v-slot:[`item.date`]="{ item }">
            <div v-if="item.data_scholar_contract">
              <b v-if="item.data_scholar_contract.attachment">
                {{
                  $date(item.data_scholar_contract.attachment_at).format(
                    "ddd, DD MMM YYYY"
                  )
                }}</b
              >
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div>
      <div class="py-3" v-if="dataSet">
        <v-row>
          <v-col cols="12" md="6">
            <div class="d-flex align-center">
              <p class="mr-2 mb-0">ROWS PER PAGE</p>
              <div style="width: 100px">
                <v-select
                  dense
                  hide-details
                  :items="rows"
                  item-text="txt"
                  item-value="val"
                  v-model="limit"
                  @change="fetchData"
                  placeholder="Contract"
                  background-color="var(--g)"
                  dark
                  flat
                  solo
                ></v-select>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="d-flex justify-end">
              <v-pagination
                v-model="page"
                color="#006341"
                @input="fetchData"
                :length="last_page"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="py-3" v-if="storage_id.length">
        <v-card class="pa-3 rounded-lg" flat>
          <v-chip
            v-for="(item, i) in storage_id"
            :key="`picked-${i}`"
            class="ma-1"
            close
            @click:close="kickUser(item)"
          >
            <v-avatar class="mr-2" left>
              <img
                :src="item.profile_picture ? item.profile_picture : ava"
                class="obj_fit"
                alt="isyan"
              />
            </v-avatar>
            {{ item.name }}
          </v-chip>
          <div class="d-flex justify-center mt-3">
            <v-btn
              depressed
              class="pa-5"
              @click="startBlast"
              v-if="!sending"
              dark
              color="var(--g)"
              >Send
              <v-icon class="ml-2">mdi-email-fast</v-icon>
            </v-btn>
            <v-btn depressed class="pa-5" v-if="sending" dark color="var(--g)"
              >Sending...
              <v-icon class="ml-2">mdi-email-fast</v-icon>
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import titlePage from "../../components/atom/titlePage.vue";
export default {
  name: "manageContract",
  computed: {
    getYear() {
      let data = [];
      let year = parseInt(this.$date().format("YYYY"));
      for (let i = 2019; i <= year; i++) {
        data.push({
          state: i,
          abbr: i,
        });
      }
      data.push({
        state: "All Year",
        abbr: "",
      });
      return data;
    },
    ...mapState({
      ava: (state) => state.ava,
    }),
  },
  components: { titlePage },
  data() {
    return {
      loading: false,
      sending: false,
      dataSet: null,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      rows: [5, 10, 50, 100],
      year: "",
      find: "",
      storage_id: [],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "no_tf",
        },
        {
          text: "FULL NAME",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "EMAIL",
          align: "start",
          sortable: false,
          value: "email",
        },
        { text: "TYPE", sortable: false, value: "type" },
        {
          text: "DATE SUBMITTED",
          align: "start",
          sortable: false,
          value: "date",
        },
        { text: "STATUS", sortable: false, value: "status" },
      ],
      pickedContract: 1,
      typeContract: [
        {
          val: 1,
          txt: "Contract-1",
        },
        {
          val: 2,
          txt: "Contract-2",
        },
        {
          val: 3,
          txt: "Contract-3",
        },
        {
          val: 4,
          txt: "Contract-4",
        },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/scholar?filter[search]=${this.find}&page[number]=${this.page}&page[size]=${this.limit}&filter[year_tf]=${this.year}&include=dataScholarContract`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    startBlast() {
      this.sending = true;
      let id = this.storage_id.map((el) => {
        return el.id;
      });
      let data = {
        path: `manage/contract/create`,
        body: {
          scholar_id: id,
          type: this.pickedContract,
        },
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.fetchData();
          this.sending = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
        })
        .catch((e) => {
          this.sending = false;
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    kickUser(i) {
      const index = this.storage_id.indexOf(i);
      if (index > -1) {
        this.storage_id.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
.input_green {
  border: 2px solid var(--g);
  border-radius: 5px;
  padding: 0 0 0 30px;
  height: 38px;
  background: #fff;
  width: 100%;
}
.input_green:focus {
  outline: none;
}
.magnify {
  margin-right: -30px;
}
</style>